// extracted by mini-css-extract-plugin
export default {"root":"q_Lme","left":"tE8r6","right":"InEAS","center":"bq34W"};